<template>

	<div class="cookie-consent" :class="{ active: active }" :style="{ height: calculatedHeight }" v-if="content">

		<div class="consent-front" :class="{ active : state === 0 }" ref="front">
			<div class="consent-front-h">
				<span>{{content.h}}</span>
			</div>
			<div class="consent-actions">
				<a href="#" class="consent-help" @click.prevent="state = 1">Customise</a>
				<a href="#" class="consent-btn" @click.prevent="agree" :style="{ 'background-color' : colour }">{{content.btn}}</a>
			</div>
		</div>

		<div class="consent-back" :class="{ active : state === 1 }" ref="back">
			<div class="consent-back-d">
				<div class="consent-back-d-p" v-html="content.p_1"></div>
				<label class="switch">
					<input type="checkbox" disabled checked>
					<span class="switch-btn disabled"></span>
				</label>
			</div>
			<hr>
			<div class="consent-back-d" v-if="analytics === 'on'">
				<div class="consent-back-d-p" v-html="content.p_2"></div>
				<label class="switch">
					<input type="checkbox" v-model="analyticsInput">
					<span class="switch-btn"></span>
				</label>
			</div>
			<div class="consent-actions">
				<a href="#" class="consent-help" @click.prevent="state = 0">Back</a>
				<a href="#" class="consent-btn" @click.prevent="agree" :style="{ 'background-color' : colour }">Confirm</a>
			</div>
		</div>

		<div id="consent-analytics"></div>

	</div>


</template>


<script type="text/babel">

  import Cookie from 'js-cookie';
  import $ from 'jquery';

  export default {

    data() {
      return {
        state: 0,
        active: false,
        calculatedHeight: 'auto',
        analyticsInput: true
      }
    },

    mounted() {
      let c = Cookie.get('consent');

      if (!c){
        setTimeout(()=>{
          this.active = true;
        }, 12000)
      }

      let ca = Cookie.get('consent-no-analytics');

      if (ca){
        this.analyticsInput = false;
      }

			if (this.content) {
        this.calcHeight();
        this.setAnalytics();
			}

    },

    props: {
      content: {type: Object, default: {}},
      policy: {type: String, default: ''},
      colour: {type: String, default: ''},
      analytics: {type: String, default: ''},
      snippet: { type: String, default: ''}
    },

    methods: {
      agree() {
        Cookie.set('consent', true, { expires: 14 });
        this.active = false
      },

      calcHeight(){
        setTimeout(()=>{
          this.state === 0
            ? this.calculatedHeight = this.$refs.front.clientHeight + 24 + 'px'
            : this.calculatedHeight = this.$refs.back.clientHeight + 24 + 'px';
        }, 500);
      },

      setAnalytics: function(){
        if (!this.analyticsInput) {
          $('#consent-analytics').text('')
          Cookie.set('consent-no-analytics', true, { expires: 14 });
        } else {
          let snippet = this.snippet.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"");
          $('#consent-analytics').append(snippet)
          Cookie.remove('consent-no-analytics');
        }
      }
    },

    watch: {
      state: function(){
        this.calcHeight();
      },

      analyticsInput: function(){
        this.setAnalytics();
      }
    }
  }

</script>